(function () {
  angular
    .module("akitabox.ui.dialogs.workOrder.complete")
    .factory("CompleteWorkOrderDialog", CompleteWorkOrderDialog);

  /* @ngInject */
  function CompleteWorkOrderDialog($log, $q, $mdDialog, $mdMedia) {
    var modal = {
      templateUrl:
        "app/core/ui/dialogs/work-order/complete/complete-work-order.dialog.html",
      controller: "CompleteWorkOrderDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: false,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog, `options.locals.workOrders` and `options.locals.building` are required
     *
     * @param  {Object}                 options                    Dialog options
     * @param  {Object}                 options.locals.workOrders  Array of work orders to be completed
     * @return {Promise<Object|Error>}                              Promise that resolves with the completed workOrders
     */
    function show(options) {
      // Verify we have workOrderIDs and building locals
      if (!options || !options.locals || !options.locals.workOrders) {
        $log.error(
          "CompleteWorkOrderDialog: you must pass in workOrders via locals"
        );
        return $q.reject("Sorry, we weren't able to complete your request.");
      }
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
